import { useFieldContext } from '../FieldContext';
import { formatCurrency } from '../format';
import { EmptyValue } from './EmptyValue';

/**
 * Amount and code travel together (field-types.md decision 4), so a column of
 * mixed currencies is obvious instead of quietly wrong.
 */
export function CurrencyDisplay() {
  const { value } = useFieldContext();
  if (value === null || typeof value !== 'object' || !('amountMicros' in value)) {
    return <EmptyValue />;
  }
  return <span className="block tabular-nums whitespace-nowrap">{formatCurrency(value)}</span>;
}
